{
  "_comment": "[CI-LOCKED] 此檔案的內容已鎖定。歡迎提供意見，但變更驗證可能會有所延遲。",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "機器人 $1 說:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agent",
  "ACTIVITY_YOU_SAID_ALT": "您說:",
  "ACTIVITY_BOT_ATTACHED_ALT": "機器人附加了:",
  "ACTIVITY_CODE_ALT": "程式碼範例: $1",
  "ACTIVITY_CONTENT_CAUTION": "AI 產生的內容可能不正確",
  "ACTIVITY_CODE_CAUTION": "AI 產生的程式碼。請仔細審查和使用",
  "ACTIVITY_ERROR_BOX_TITLE": "錯誤訊息",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "按一下以進行互動。",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "訊息為互動式訊息。",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "訊息中有一或多個連結。",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "傳送失敗。",
  "ACTIVITY_YOU_ATTACHED_ALT": "您附加了:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 個附件。",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 個附件。",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 個附件。",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 個附件。",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 個附件。",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "傳送失敗。[重試][RETRY]。",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "正在傳送",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "於 $1 傳送",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "剛剛",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "1 小時前",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "1 分鐘前",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "今天",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "昨天",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "調適型卡片剖析錯誤",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "調適型卡片轉譯錯誤",
  "ATTACHMENT_AUDIO": "音訊剪輯。",
  "ATTACHMENT_CARD": "卡片: $1 $2 $3",
  "ATTACHMENT_FILE": "檔案: $1",
  "ATTACHMENT_IMAGE": "影像",
  "ATTACHMENT_TEXT": "文字: $1",
  "ATTACHMENT_VIDEO": "視訊剪輯",
  "AVATAR_ALT": "$1虛擬人偶",
  "CAROUSEL_FLIPPER_NEXT_ALT": "下一個",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "上一個",
  "CITATION_MODEL_DIALOG_ALT": "引用",
  "CLOSE_BUTTON_ALT": "關閉",
  "COLLAPSIBLE_GROUPING_TITLE": "思考中...",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "當機器人在群組中撰寫回覆訊息時，若未提供摘要，則會顯示此訊息。",
  "COLLAPSE_BUTTON_LESS": "顯示較少",
  "COLLAPSE_BUTTON_LESS.comment": "這是用於摺疊訊息群組的＞形箭號按鈕的文字。當終端使用者按一下該按鈕時，訊息群組會摺疊。",
  "COLLAPSE_BUTTON_MORE": "顯示更多",
  "COLLAPSE_BUTTON_MORE.comment": "這是用於展開訊息群組的＞形箭號按鈕的文字。當終端使用者按一下該按鈕時，訊息群組會展開。",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "已連線",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "正在連線…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "無法連線。",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "發生網路中斷。正在重新連線…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "轉譯錯誤。請檢查主控台或連絡機器人開發人員。",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "連線所需的時間比平時更長。",
  "CONNECTIVITY_STATUS_ALT": "連線狀態: $1",
  "COPY_BUTTON_TEXT": "複製",
  "COPY_BUTTON_COPIED_TEXT": "已複製",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "提交",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "取消",
  "FEEDBACK_FORM_PLACEHOLDER": "請盡量提供更多細節，但請勿包括任何私人或敏感性資訊。",
  "FEEDBACK_FORM_TITLE": "請告訴我們您的體驗",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "下載 '$1' 檔案",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "下載 '$1' 檔案，大小為 $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "'$1'，大小為 $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "在新視窗中開啟; 外部。",
  "RECEIPT_CARD_TAX": "稅金",
  "RECEIPT_CARD_TOTAL": "總計",
  "RECEIPT_CARD_VAT": "加值稅",
  "REFERENCE_LIST_HEADER_ONE": "$1 個參考",
  "REFERENCE_LIST_HEADER_FEW": "$1 個參考",
  "REFERENCE_LIST_HEADER_MANY": "$1 個參考",
  "REFERENCE_LIST_HEADER_OTHER": "$1 個參考",
  "REFERENCE_LIST_HEADER_TWO": "$1 個參考",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "刪除附件 $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "刪除",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "一個檔案",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "一個影像",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "無法傳送空白訊息。",
  "SPEECH_INPUT_LISTENING": "正在聆聽…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "關閉麥克風",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "開啟麥克風",
  "SPEECH_INPUT_STARTING": "正在啟動…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "下一個",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "上一個",
  "SUGGESTED_ACTIONS_LABEL_ALT": "建議的動作",
  "TEXT_INPUT_ALT": "訊息輸入方塊",
  "TEXT_INPUT_PLACEHOLDER": "輸入您的訊息",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "開始說話...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "正在聆聽...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "正在處理...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "說話以中斷...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "傳送",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "說話",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "上傳檔案",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "電話鍵盤",
  "TEXT_INPUT_DROP_ZONE": "放置檔案",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "訊息長度已超過",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "僅支援個位數輸入",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 個附件",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 個附件",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 個附件",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 個附件",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 個附件",
  "TOAST_ACCORDION_FEW": "$1 則通知: 按一下這裡來查看詳細資料",
  "TOAST_ACCORDION_MANY": "$1 則通知: 按一下這裡來查看詳細資料",
  "TOAST_ACCORDION_OTHER": "$1 則通知: 按一下這裡來查看詳細資料",
  "TOAST_ACCORDION_TWO": "$1 則通知: 按一下這裡來查看詳細資料",
  "TOAST_ALT_ERROR": "錯誤",
  "TOAST_ALT_INFO": "資訊",
  "TOAST_ALT_SUCCESS": "成功",
  "TOAST_ALT_WARN": "警告",
  "TOAST_DISMISS_BUTTON": "關閉",
  "TOAST_TITLE_ALT": "通知",
  "TRANSCRIPT_ARIA_LABEL_ALT": "聊天記錄，按方向鍵進行瀏覽。",
  "TRANSCRIPT_ARIA_ROLE_ALT": "聊天記錄",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "訊息為互動式。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "訊息中的一或多個連結。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "訊息有建議的動作。請按下 Shift Tab 2 至 3 次選取它們。",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "訊息有建議的動作。請按下 $1 選取它們。",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "無法傳送訊息。",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "有新訊息可用。按 $1 將焦點設於 [$2] 按鈕。",
  "TRANSCRIPT_MORE_MESSAGES": "更多訊息",
  "TRANSCRIPT_NEW_MESSAGES": "新訊息",
  "TRANSCRIPT_TERMINATOR_TEXT": "聊天記錄結尾",
  "TYPING_INDICATOR_ALT": "顯示輸入指示器",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 正在鍵入。",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 和其他人正在鍵入。",
  "VIEW_CODE_BUTTON_TEXT": "程式碼",
  "VOTE_COMPLETE_ALT": "已記錄意見反應",
  "VOTE_COMPLETE_ALT.comment": "這用於螢幕助讀程式。帶有拇指向上/向下圖示的按鈕標籤。該標籤會在記錄意見反應時使用。",
  "VOTE_DISLIKE_ALT": "不喜歡",
  "VOTE_LIKE_ALT": "喜歡"
}